import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        cardTitle: {
            marginBottom: `${theme.spacing(2)} !important`,
        },
    }
})

export default useStyles
